<script setup lang="ts">
import { useUiStore } from '@/stores/ui'
import AppDialog from './AppDialog.vue'
import AppIcon from './AppIcon.vue'

const ui = useUiStore()

function close(value: boolean): void {
  ui.answerConfirm(value)
}
</script>

<template>
  <AppDialog
    :model-value="ui.confirmState.open"
    :title="ui.confirmState.options.title"
    width="440px"
    @update:model-value="value => { if (!value) close(false) }"
  >
    <div class="confirm-body">
      <span class="confirm-icon" :class="{ 'confirm-icon--danger': ui.confirmState.options.tone === 'danger' }">
        <AppIcon :name="ui.confirmState.options.tone === 'danger' ? 'warning' : 'info'" :size="20" />
      </span>
      <div>
        <p class="confirm-message">{{ ui.confirmState.options.message }}</p>
        <p v-if="ui.confirmState.options.detail" class="confirm-detail">{{ ui.confirmState.options.detail }}</p>
      </div>
    </div>
    <template #footer>
      <button class="btn" type="button" @click="close(false)">{{ ui.confirmState.options.cancelText ?? '取消' }}</button>
      <button
        class="btn"
        :class="ui.confirmState.options.tone === 'danger' ? 'btn--danger' : 'btn--primary'"
        type="button"
        @click="close(true)"
      >
        {{ ui.confirmState.options.confirmText ?? '确认' }}
      </button>
    </template>
  </AppDialog>
</template>
